import { FC } from 'react';
import { Skeleton, Stack } from '@chakra-ui/react';

import { FORM_FIELD_CLASS_NAME } from '../../constants/styles';

export const LoadingField: FC = () => (
  <Stack className={FORM_FIELD_CLASS_NAME}>
    <Skeleton h={4} w={32} />
    <Skeleton h={10} />
  </Stack>
);
